import { render, staticRenderFns } from "./ProductApprove.vue?vue&type=template&id=1429295f"
import script from "./ProductApprove.vue?vue&type=script&lang=js"
export * from "./ProductApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports